import { getNestedValue, normalize } from 'helpers';
import { useState, useMemo } from 'react';

interface UseFilterProps<T> {
  data: T[];
  fields: { field: string }[];
}

export function useFilter<T extends object>({ data, fields }: UseFilterProps<T>) {
  const [filterText, setFilterText] = useState('');

  const filteredData = useMemo(() => {
    const normalizedFilter = normalize(filterText);

    const filtered = !normalizedFilter
      ? data
      : data.filter(item =>
          fields.some(field => {
            const value = getNestedValue(item, field.field);
            return normalize(value).includes(normalizedFilter);
          })
        );

    return [...filtered].sort((a, b) => {
      const aDate = new Date((a as any).created_at || 0);
      const bDate = new Date((b as any).created_at || 0);
      return bDate.getTime() - aDate.getTime();
    });
  }, [data, filterText, fields]);

  return {
    filterText,
    setFilterText,
    filteredData,
  };
}

